module.exports = __webpack_public_path__ + "img/04.01a35096.jpg";